const ITEMS = {
    'ADD': '+',
    'SUBTRACT': '-',
    'DIVIDE': '/',
    'MULTIPLY': 'x'
};

export default ITEMS;